import React from 'react';

import { BrowserSizeContext } from './useBrowserSize';

function useWithinSizeList(sizes: string[] | undefined) {
  const browserSize = React.useContext(BrowserSizeContext);

  if (!sizes || !sizes.length) {
    return undefined;
  }

  return sizes.indexOf(browserSize) > -1;
}

export default useWithinSizeList;
